import styles from "./styles.module.scss";
import { Tag } from "ui-kit-v2/src/tag/tag";
import { _ } from "i18n";

interface CoachReviewsStatusTagProps {
	status: "draft" | "sent";
}

const PALETTE = { draft: "neutral", sent: "green" } as const;

export const CoachReviewsStatusTag = ({ status }: CoachReviewsStatusTagProps) => (
	<Tag variant="secondary" palette={PALETTE[status]} className={styles.tag}>
		{_(`game.coachReviews.badge.${status}`)}
	</Tag>
);
